import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import EnumService from 'services/enum2';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import { Link } from 'react-router-dom';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import { withStyles } from '@material-ui/core/styles';
import { BILLTYPE_MAP, DAILY_ORDER_REMINDER } from 'constants/billType.ts';

/*
https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=https%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fmessage%2Fdetail%2F94563778%2Fd3e64750039d8132e6524ccfd7bf1cb3&response_type=code&scope=snsapi_base&state=123#wechat_redirect
*/
const styles = theme => ({
  paper: {
    margin: '10px',
    width: '90vw'
  }
});
function MessageDetail(props) {
  const config = {
    title: '每日提醒',
    apiPath: '/archives/orderAlterMsg/detail',
    companyCodeKey: 'companyCode',
    idField: 'alertXkUniqueCode'
  };
  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    moreSign1,
    moreSign2,
    handleMore,
    setShowLoading,
    setRedirect,
    detail,
    setDetail,
    self
  } = useDetail(props, config);

  // const [canResponse, setCanResponse] = useState(false);
  // const { state, dispatch } = useContext(ActionContext);
  const [arrGroupData, setArrGroupData] = useState([]);

  //处理详情数据
  self.afterGetDetail = function (data) {
    let arr = [];
    if (typeof data === 'object' && !Array.isArray(data)) {
      for (let key in data) {
        arr.push(data[key]);
      }
    }
    getOrderAlterMsg(arr);
    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);

    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  async function getOrderAlterMsg(msgData) {
    if (Util.isEmpty(msgData)) {
      return;
    }
    // msgData.arrGroupData = [];
    let objGroupData = {}; //分组数据
    let objEnumData = {}; //枚举数据
    if (Util.isEmpty(objEnumData['B02_Daily_Belonging_Category'])) {
      objEnumData['B02_Daily_Belonging_Category'] = await EnumService.getList(
        'B02_Daily_Belonging_Category'
      );
    }
    EnumService.getList('B02_Daily_Order_Reminder').then(enumData => {
      if (!Util.isEmpty(enumData)) {
        // msgData.sort((a, b) => Number(a.orderType) - Number(b.orderType));
        msgData.forEach(item => {
          enumData.some(val => {
            if (val.subKey === item.orderStatusType) {
              item.orderStatusTypeName = val.subValue;
            }
            return val.subKey === item.orderStatusType;
          });
          //每日提醒配置
          let remindConfig = DAILY_ORDER_REMINDER[item.orderStatusType];
          if (remindConfig && remindConfig.routerLink) {
            item.routerLink = remindConfig.routerLink;
            if (!Util.isEmpty(remindConfig.queryParams)) {
              let keys = Object.keys(remindConfig.queryParams);
              let values = Object.values(remindConfig.queryParams);
              item.routerLink += '?' + keys[0] + '=' + values[0];
            }
          }
          //按提醒类型归类
          if (objGroupData[item.reminderType] === undefined) {
            objGroupData[item.reminderType] = [];
          }
          objGroupData[item.reminderType].push(item);
        });
        //页面渲染数据
        let arr = [];
        Object.keys(objGroupData).forEach((reminderType, index) => {
          let totalCount = 0,
            reminderTypeName = '';
          if (Array.isArray(objGroupData[reminderType])) {
            objGroupData[reminderType].forEach(sub => {
              totalCount += sub.orderStatCount || 0;
            });
          }
          if (Array.isArray(objEnumData['B02_Daily_Belonging_Category'])) {
            objEnumData['B02_Daily_Belonging_Category'].some(val => {
              if (val.subKey === String(reminderType)) {
                reminderTypeName = val.subValue;
              }
              return val.subKey === String(reminderType);
            });
          }
          if (reminderTypeName) {
            arr[index] = {
              reminderType: reminderType,
              reminderTypeName: reminderTypeName,
              totalCount: totalCount,
              data: objGroupData[reminderType]
            };
          }
        });
        setArrGroupData(arr);
      }
    });
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  //路由跳转
  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>每日提醒</label>
          </div>
          <div className="details-item-content order-alter-msg">
            {arrGroupData.map((item, index) => (
              <div className="order-alter-type" key={index}>
                <div className="order-alter-type-name">
                  {item.reminderTypeName}
                  <span>（{item.totalCount}）</span>
                </div>
                {Array.isArray(item.data) && (
                  <ul className="order-alter-type-sub-list">
                    {item.data.map((sub, idx) => (
                      <li className="order-alter-type-sub" key={idx}>
                        {sub.routerLink && (
                          <Link to={sub.routerLink}>
                            {sub.orderStatusTypeName}
                          </Link>
                        )}
                        {!sub.routerLink && (
                          <span>{sub.orderStatusTypeName}</span>
                        )}
                        <span>（{sub.orderStatCount}）</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <Modal></Modal>
    </div>
  );
}

MessageDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(MessageDetail));
